import { Globe } from '@phosphor-icons/react';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { createSafeContext } from './ui/utils';

import { Option, Select } from '~/components/ui/select';
import { LanguageState } from '~/contexts/lang/languageContext';
import { Language } from '~/interfaces/Language';
import { RootState } from '~/utils/store';

// *****NOTE: This is a dummy implementation of the refactored Language Context
// Temporarily commented some of the code to avoid errors

// const SUPPORTED_LANGUAGES = ['en', 'fr', 'de', 'nl'] as const;
// type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
// const isSupportedLanguage = (lang: string): lang is SupportedLanguage =>
//   SUPPORTED_LANGUAGES.includes(lang as SupportedLanguage);

// export const LANGUAGE_LIST: Array<{ value: SupportedLanguage; title: string }> =
//   [
//     {
//       value: 'en',
//       title: 'English',
//     },
//     {
//       value: 'fr',
//       title: 'French',
//     },
//     {
//       value: 'de',
//       title: 'Deutsch',
//     },
//     {
//       value: 'nl',
//       title: 'Dutch',
//     },
//   ];

// const [SafeLanguageProvider, useLangContext] = createSafeContext<
//   Omit<LanguageState, 'setLanguage'> & {
//     setLanguage: (lang: SupportedLanguage) => void;
//   }
// >('Language Context Error');

const [SafeLanguageProvider, useLangContext] = createSafeContext<
Omit<LanguageState, 'setLanguage'> & {
  setLanguage: (lang: Language) => void;
}
>('Language Context Error');

const LOCAL_STORAGE_LANG_KEY = 'lang';
const language = JSON.parse(localStorage.getItem('lang') ?? 'null');
export const DEFAULT_LANGUAGE = { name : 'English', code: 'en', id: 19 };

export { useLangContext };
export function LanguageProvider(props: { children: React.ReactNode }) {
  // *****NOTE: This is a dummy implementation of the refactored Language Context
  // Temporarily commented some of the code to avoid errors

  // const LOCAL_STORAGE_LANG_KEY = 'lang';
  // const DEFAULT_LANGUAGE = 'en';

  // const [language, setLanguage] = useState(
  //   localStorage.getItem(LOCAL_STORAGE_LANG_KEY) ?? DEFAULT_LANGUAGE,
  // );

  // const languageChangeHandler = useCallback((value: SupportedLanguage) => {
  //   setLanguage(value);
  //   localStorage.setItem('lang', value);
  // }, []);

  const [selectedLanguage, setLanguage] = useState(
    language ?? DEFAULT_LANGUAGE,
  );

  const languageChangeHandler = useCallback((value: Language) => {
    setLanguage(value);
    const stringifiedLanguage = JSON.stringify(value);

    localStorage.setItem(LOCAL_STORAGE_LANG_KEY, stringifiedLanguage);
  }, []);

  // *****NOTE: This is a dummy implementation of the refactored Language Context
  // Temporarily commented some of the code to avoid errors

  // return (
  //   <SafeLanguageProvider
  //     {...props}
  //     value={{ selectedLanguage: language, setLanguage: languageChangeHandler }}
  //   />
  // );

  return (
    <SafeLanguageProvider
      {...props}
      value={{ selectedLanguage: selectedLanguage, setLanguage: languageChangeHandler }}
    />
  );
}

export function LanguageSelect(
  props: Omit<React.ComponentPropsWithoutRef<typeof Select>, 'startDecorator'>,
) {
  const ctx = useLangContext();

  const tenantLanguages = useSelector(
    (state: RootState) => state.tenant.languages,
  );

  // *****NOTE: This is a dummy implementation of the refactored Language Context
  // Temporarily commented some of the code to avoid errors

  // return (
  //   <Select
  //     {...props}
  //     startDecorator={<Globe />}
  //     placeholder='Select Language'
  //     onChange={(_e, value) => {
  //       const selectedValue = value ? String(value) : 'en';
  //       if (value && isSupportedLanguage(selectedValue)) {
  //         ctx.setLanguage(selectedValue);
  //         localStorage.setItem('lang', selectedValue);
  //       }
  //     }}
  //     value={ctx.selectedLanguage}
  //   >
  //     {LANGUAGE_LIST.map((language) => (
  //       <Option key={language.value} value={language.value}>
  //         {language.title}
  //       </Option>
  //     ))}
  //   </Select>
  // );

  return (
    <Select
      {...props}
      startDecorator={<Globe />}
      placeholder='Select Language'
      onChange={(_e, value) => {
        if (value && typeof value === 'object') {
          ctx.setLanguage(value as Language);
          const stringifiedLanguage = JSON.stringify(value);
      
          localStorage.setItem(LOCAL_STORAGE_LANG_KEY, stringifiedLanguage);
        }
      }}
      value={ctx.selectedLanguage}
    >
      {tenantLanguages.map((item) => (
        <Option key={item.id} value={item.code}>
          {item.name}
        </Option>
      ))}
    </Select>
  );
}
